import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { setTenantList, componentKey as xeroComponentKey, setImportData, setLoadingState, setFormAndTaxYearList, setIsImportDataGridViewLoaded, setFormSettings, setAuthorizationUrl } from "./XeroSlice";
import IntegrationDataService from "../../../../../services/IntegrationDataService";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { INTEGRATION_WRAPPER_LOADING_STATES } from "../constants";
import FormsDataService from "../../../../../services/FormsDataService";

export const { getXeroUrl, connectToXero, disconnectToXero, getLoadImportData, getFormAndTaxYearList, getFormSetting } = {
    getXeroUrl: (payload) => {
        return {
            type: "XERO/GET_AUTHENTICATEURL",
            payload: payload
        }
    },
    connectToXero: (payload) => {
        return {
            type: "XERO/GET_CONNECTXERO",
            payload: payload
        }
    },
    disconnectToXero: (payload) => {
        return {
            type: "XERO/GET_DISCONNECTXERO",
            payload: payload
        }
    },
    getLoadImportData: (payload) => {
        return {
            type: "XERO/GET_LOAD_IMPORT_DATA",
            payload: payload
        }
    },
    getFormAndTaxYearList: (payload) => {
        return {
            type: "XERO/GET_FORMS_TAXTEAR_LIST",
            payload: payload
        }
    },
    getFormSetting: (payload) => {
        return {
            type: "XERO/GET_FORM_SETTING",
            payload: payload
        }
    },
}

function* getXeroUrlAsync() {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const response = yield IntegrationDataService.index();
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setAuthorizationUrl(response?.data?.Data));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({
            heading: "Failed to fetch Xero Url",
            message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.",
            variant: TOASTER_VARIANT.DANGER
        }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}
function* connectToXeroAsync(action) {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const response = yield IntegrationDataService.connectXero(action.payload);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            const tenantData = response?.data?.Data || [];
            yield put(setTenantList(tenantData));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({
            heading: "Failed to Connect Xero",
            message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.",
            variant: TOASTER_VARIANT.DANGER
        }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}
function* disconnectToXeroAsync(action) {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const { removedTenant, tenants } = action.payload;
        const response = yield IntegrationDataService.disconnectXero(removedTenant);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(addNotifications({
                heading: "Disconnected",
                message: "You have been successfully disconnected.",
                variant: TOASTER_VARIANT.SUCCESS
            }))
            const updatedTenantList = tenants.filter(tenant => tenant.TenantId !== removedTenant.idForTenant);
            yield put(setTenantList(updatedTenantList));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({
            heading: "Failed to Disconnect Xero",
            message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.",
            variant: TOASTER_VARIANT.DANGER
        }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}
function* getLoadImportDataAsync(action) {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const { integrationImportRequestDto } = action.payload;
        const response = yield IntegrationDataService.getIntegrationImportData(integrationImportRequestDto);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setImportData(response?.data?.Data));
            yield put(setIsImportDataGridViewLoaded(true));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({
            heading: "Failed to fetch Import Data",
            message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.",
            variant: TOASTER_VARIANT.DANGER
        }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}
function* getFormAndTaxYearListAsync() {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const response = yield IntegrationDataService.getTaxYearFormTypes();
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setFormAndTaxYearList(response?.data?.Data));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({
            heading: "Failed to fetch TaxYear And Form Types",
            message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.",
            variant: TOASTER_VARIANT.DANGER
        }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}

function* getFormSettingAsync(action) {
    try {
        const { formId, year } = action.payload;
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GET_FORM_SETTINGS_LOADING }));
        const response = yield FormsDataService.getFormSetting(formId, year);
        if (response?.data) {
            if (response?.data?.Status === 1) {
                yield put(setFormSettings(response?.data?.Data));
            } else {
                yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.",
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GET_FORM_SETTINGS_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getXeroUrl().type, getXeroUrlAsync),
        takeLatest(connectToXero().type, connectToXeroAsync),
        takeLatest(disconnectToXero().type, disconnectToXeroAsync),
        takeLatest(getLoadImportData().type, getLoadImportDataAsync),
        takeLatest(getFormAndTaxYearList().type, getFormAndTaxYearListAsync),
        takeLatest(getFormSetting().type, getFormSettingAsync),
    ]);
}

store.sagaManager.addSaga(xeroComponentKey, rootSaga);